
import Icon from '../../../components/AppIcon';

interface SummaryCardProps {
  title: string;
  value: string | number;
  iconName: string;
  iconColor: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  description?: string;
}

const SummaryCard = ({ title, value, iconName, iconColor, trend, description }: SummaryCardProps) => {
  return (
    <div className="bg-card border border-border rounded-xl p-4 sm:p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-[1.02] cursor-pointer">
      <div className="flex items-start justify-between mb-3 sm:mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm text-muted-foreground mb-1 font-medium uppercase tracking-wide">{title}</p>
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground truncate">{value}</h3>
        </div>
        <div
          className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ml-2 sm:ml-3 transform transition-transform duration-300 hover:rotate-12"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={iconName} size={20} color={iconColor} className="sm:w-6 sm:h-6" />
        </div>
      </div>

      {trend && (
        <div className="flex items-center gap-1.5 sm:gap-2 mb-2 flex-wrap">
          <Icon
            name={trend.isPositive ? 'TrendingUp' : 'TrendingDown'}
            size={14}
            color={trend.isPositive ? 'var(--color-success)' : 'var(--color-error)'}
            className="sm:w-4 sm:h-4"
          />
          <span className={`text-xs sm:text-sm font-semibold ${trend.isPositive ? 'text-success' : 'text-error'}`}>
            {trend.isPositive ? '+' : ''}{trend.value}%
          </span>
          <span className="text-xs sm:text-sm text-muted-foreground hidden sm:inline">vs last period</span>
        </div>
      )}

      {description && (
        <p className="text-xs sm:text-sm text-muted-foreground font-medium">{description}</p>
      )}
    </div>
  );
};

export default SummaryCard;